module.exports = __webpack_public_path__ + "media/images/my_apps/ohap_my_apps_atlas_banner-74b2b4818f35c2b57967a7820ebd8966.png";